import { ExecutionStates } from 'automation-ui-log-events/constants/LogEventConstants';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { View } from 'foundations-components/components/View';
import SimulatedActionExecutionEvent from 'automation-ui-canvas/components/test-flow/SimulatedActionExecutionEvent';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import ValidationLabelIcon from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/ValidationLabelIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RunStatusAlert = ({
  event,
  objectId,
  flow
}) => {
  const isFailed = event.executionState === ExecutionStates.FAIL_IRREPARABLE || event.executionState === ExecutionStates.FAIL_RETRY || event.executionState === ExecutionStates.FAIL_CONTINUE || event.executionState === ExecutionStates.FAIL_RESCHEDULE;
  return /*#__PURE__*/_jsxs(Alert, {
    type: isFailed ? 'danger' : 'success',
    children: [/*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      alignSelf: "center",
      children: [/*#__PURE__*/_jsx(View, {
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(ValidationLabelIcon, {
          status: isFailed ? 'FAILED' : 'PASSED'
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h7",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isFailed ? 'debuggerPanel.step.execution.runStatus.failure' : 'debuggerPanel.step.execution.runStatus.success'
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "400",
      paddingInlineStart: "500",
      children: /*#__PURE__*/_jsx(SimulatedActionExecutionEvent, {
        event: event,
        objectId: objectId,
        flowObjectTypeId: flow.getObjectTypeId(),
        flow: flow,
        hideHeader: true
      })
    })]
  });
};
export default RunStatusAlert;